import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
// import "../../mixins.scss";
import './footer.scss';

function Footer(props) {
  const { components, page } = props;

  return (
    <>
      <div
        className={cn(
          'footer',
          components === 'two' && 'footer--growth',
          components === 'tm' && 'footer--tm',
          components === 'three' && 'footer--three',
          page && 'footer--page',
        )}>

		{components !== 'tm' && components !== 'three' && (
			<>
			{/* <div className="lang footer__lang">
          <span>En</span>
        </div> */}
        {/* <div className="share footer__share">
          <a href="#" className="share__btn"></a>
        </div> */}
			</>

		)}
        {components === 'tm' && (
          <div className="footer timeline-horizontally__footer">
            <div className="years years--active-1 footer__years">
              <a href="#m2007" className="years__item">2007</a>
              <a href="#m2008" className="years__item">2008</a>
              <a href="#m2009" className="years__item">2009</a>
              <a href="#m2010" className="years__item">2010</a>
              <a href="#m2011" className="years__item">2011</a>
            </div>
          </div>
        )}
        {components === 'three' && (
          <div className="footer timeline-horizontally__footer">
            <div className="years years--active-1 footer__years">
              <a href="#y2017" className="years__item">2017</a>
              <a href="#y2018" className="years__item">2018</a>
              <a href="#y2019" className="years__item">2019</a>
              <a href="#y2020" className="years__item">2020</a>
              <a href="#y2021" className="years__item">2021</a>
              <a href="#y2022" className="years__item">2022</a>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Footer;
